import { ActionType, createReducer } from 'typesafe-actions'

import * as Actions from './actions'
import { AgreementOfferState } from './types'

const INITIAL_STATE: AgreementOfferState = {
  error: '',
  list: [],
  loading: false,
  request_totals: {
    total_emissions: 0,
    total_quotations: 0
  },
  sendAgreementOfferError: '',
  sendAgreementOfferLoading: false,
  total_results: 0
}

const reducer = createReducer<AgreementOfferState, ActionType<typeof Actions>>(
  INITIAL_STATE
)
  .handleAction(Actions.sendAgreementOffer, state => ({
    ...state,
    sendAgreementOfferError: '',
    sendAgreementOfferLoading: true
  }))
  .handleAction(Actions.sendAgreementOfferFailure, (state, { payload }) => ({
    ...state,
    sendAgreementOfferError: payload.message,
    sendAgreementOfferLoading: false
  }))
  .handleAction(Actions.sendAgreementOfferSuccess, state => ({
    ...state,
    sendAgreementOfferLoading: false
  }))

export default reducer
